import axios from "axios";
import {
  BlacklistEntityType,
  BlacklistMatchResolutionRequest,
  BlacklistMatchResolutionRequestStatus,
  CreateBlacklistMatchResolutionRequestDto,
  CreateRemovalRequestDto,
  RemovalRequest,
  RemovalRequestDto,
  RemovalRequestStatus
} from "./types";

export const openBulletin = (id: string, asDownload: boolean) => {
  window.open(`/api/blacklist/openBulletin?id=${id}&asDownload=${asDownload}`, "_blank");
};

export const createRemovalRequest = async (dto: CreateRemovalRequestDto) => {
  await axios.post("/api/blacklist/createRemovalRequest", dto);
};

export const approveRemovalRequest = async (request: RemovalRequest) => {
  await axios.post("/api/blacklist/approveRemovalRequest", request);
};

export const rejectRemovalRequest = async (request: RemovalRequest) => {
  await axios.post("/api/blacklist/rejectRemovalRequest", request);
};

export const reinstateRequest = async (request: RemovalRequest) => {
  await axios.post("/api/blacklist/reinstateFromRemovalRequest", request);
};

export const createMatchResolutionRequest = async (dto: CreateBlacklistMatchResolutionRequestDto) => {
  await axios.post("/api/blacklist/createMatchResolutionRequest", dto);
};

export const getMatchResolutionRequests = async (status?: BlacklistMatchResolutionRequestStatus): Promise<BlacklistMatchResolutionRequest[]> => {
  const { data } = await axios.get<BlacklistMatchResolutionRequest[]>("/api/blacklist/getMatchResolutionRequests", {
    params: status === undefined ? undefined : { status }
  });
  return data;
};

export const approveMatchResolutionRequest = async (request: BlacklistMatchResolutionRequest) => {
  await axios.post("/api/blacklist/approveMatchResolutionRequest", request);
};

export const rejectMatchResolutionRequest = async (request: BlacklistMatchResolutionRequest) => {
  await axios.post("/api/blacklist/rejectMatchResolutionRequest", request);
};

export const openProofDocument = (id: string, asDownload: boolean = false) => {
  window.open(`/api/blacklist/openProofDocument?id=${encodeURIComponent(id)}&asDownload=${asDownload}`, "_blank");
};

export const getStatusLabel = (status?: RemovalRequestStatus): string => {
  switch (status) {
    case RemovalRequestStatus.Pending:
      return "Pending";
    case RemovalRequestStatus.Approved:
      return "Approved";
    case RemovalRequestStatus.Rejected:
      return "Rejected";
    default:
      return "Unknown";
  }
};

export const getMatchResolutionStatusLabel = (status?: BlacklistMatchResolutionRequestStatus): string => {
  switch (status) {
    case BlacklistMatchResolutionRequestStatus.Pending:
      return "Pending";
    case BlacklistMatchResolutionRequestStatus.Approved:
      return "Approved";
    case BlacklistMatchResolutionRequestStatus.Rejected:
      return "Rejected";
    default:
      return "Unknown";
  }
};

export const getRemovalRequest = async (
  entityId: number,
  entityType: BlacklistEntityType
): Promise<RemovalRequest | null> => {
  try {
    let url;
    switch (entityType) {
      case BlacklistEntityType.Company:
        url = "/api/blacklist/getEntityWithRemovalRequest";
      case BlacklistEntityType.Person:
        url = "/api/blacklist/getEntityWithRemovalRequest";
      case BlacklistEntityType.Property:
        url = "/api/blacklist/getEntityWithRemovalRequest";
    }

    const { data } = await axios.get<RemovalRequest>(``, {
      params: { entityId, entityType }
    });
    return data;
  } catch (error) {
    console.error("Error fetching removal request:", error);
    return null;
  }
};
